(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('VCUserDetailController', VCUserDetailController);

    VCUserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VCUser', 'User'];

    function VCUserDetailController($scope, $rootScope, $stateParams, entity, VCUser, User) {
        var vm = this;

        vm.vCUser = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:vCUserUpdate', function(event, result) {
            vm.vCUser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
